export const location = {
  add: {
    label: "Ajouter une localisation",
  },
  delete: {
    label: "Supprimer la localisation",
  },
  form: {
    add: {
      label: "Ajouter une localisation",
    },
    associateLocationWith: "Associer cette localisation avec",
    description: {
      label: "Description",
    },
    edit: {
      label: "Modifier la localisation",
    },
    informations: "Informations de la localisation",
    photo: {
      label: "Photo",
    },
    name: {
      label: "Nom",
    },
    organization: {
      label: "Organisation",
    },
  },
  statistics: {
    interventionsStatus: "État des interventions",
  },
};
